import { authFetch } from '../components/MedicationExtras';
import { takeFillMode } from './fillable';

// The agency's own PDFs; the server only types into their boxes, every word and the layout stay as uploaded
export const EXACT_FORMS = {
  admission_consent_exact: { name: 'Admission Consent (IVORY form)', file: 'Admission_Consent_IVORY.pdf' },
  admission_packet_exact: { name: 'Admission Packet HHA (IVORY form)', file: 'Admission_Packet_HHA_IVORY.pdf' },
};

// mode: prefill | blank | flat | print (print = flat copy sent to the printer by the caller)
export const fetchExactPdf = async (formId, patientId, values, mode) => {
  const res = await authFetch(`/exact-forms/${formId}/pdf`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ patientId: patientId || null, values: values || null, mode: mode === 'print' ? 'flat' : mode || 'prefill' }),
  });
  if (!res.ok) throw new Error(`Form render failed (${res.status})`);
  return res.blob();
};

// used by the AI generator export: the download dialog has already chosen the mode
export const fetchExactPdfForExport = (formId, patientId, values) => fetchExactPdf(formId, patientId, values, takeFillMode() || 'prefill');
